import { render, staticRenderFns } from "./learnSafeCourse.vue?vue&type=template&id=087350dc&scoped=true"
import script from "./learnSafeCourse.vue?vue&type=script&lang=js"
export * from "./learnSafeCourse.vue?vue&type=script&lang=js"
import style0 from "./learnSafeCourse.vue?vue&type=style&index=0&id=087350dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087350dc",
  null
  
)

export default component.exports